import parse from "html-react-parser";
import type { ReactNode } from "react";

/**
 * Render a fragment of CMS-authored HTML.
 *
 * POI descriptions, field values and block titles are rich text in Squidex, so
 * they arrive as HTML strings. The legacy app ran them through `react-html-parser`,
 * which is React 16-only and unmaintained; this is its maintained successor with
 * the same contract — the HTML is converted into React elements rather than
 * assigned to `innerHTML`.
 *
 * That distinction is the reason not to reach for `dangerouslySetInnerHTML`:
 * going through React means an inline `onerror="…"` in tenant content is a string
 * where React expects a function, so React refuses it instead of the browser
 * running it. The content is first-party — a tenant's own editors, through our
 * backend — but "first-party" here means "a CMS user", not "a developer".
 *
 * No `"use client"`: this renders identically on the server, which the POI route
 * needs.
 */
export function RichText({ html }: { html: string | null | undefined }): ReactNode {
  if (!html) return null;
  return <>{parse(html)}</>;
}
